import type { TranslationKey } from "@msuite/utils/locales";
import { useTranslation as useTranslationRaw } from "react-i18next";

export function useTranslation() {
	const {
		t,
		i18n: { language },
	} = useTranslationRaw();

	function translate(key: TranslationKey | null, replace?: Record<string, string>): string {
		if (!key) return "";
		let translated = (t(key).trim() ?? "").replace(/\s+/g, " ");
		const replacedKeys = Object.entries(replace ?? {});

		for (const [key, value] of replacedKeys) {
			translated = translated.replace(new RegExp(`{${key}}`, "g"), value);
		}

		return translated;
	}

	return { t: translate, language };
}

export type TranslationFn = ReturnType<typeof useTranslation>["t"];
